import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-pdf-renderer-wrapper',
  templateUrl: './pdf-renderer-wrapper.component.html',
  styleUrls: ['./pdf-renderer-wrapper.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PdfRendererWrapperComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<PdfRendererWrapperComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
  }

  closePdfViewer(): void {
    this.dialogRef.close();
  }

  onPdfError(event: any): void {
    if (event.isError) {
      this.dialogRef.close();
    }
  }
}
